module.exports = __webpack_public_path__ + "img/20200109160016545.ce1e790a.jpg";